import { Container, Row } from '@algbra/ui/components/Grid/Grid'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { resolveAsAttachment } from '@algbra/ui/resolvers'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import { map } from 'rambdax'
import { FooterStoreLinks } from '../../types/footer'
import { ReactComponent as QrCodeIcon } from '../../images/referrals/universal-qr.svg'

import styles from './DownloadTheApp.module.scss'
import Button from '@algbra/ui/components/Button/Button'
import { navigate } from 'gatsby'

export type ZoneDownloadTheAppProps = {
  __typename: 'StrapiGQL_ComponentZonesDownloadTheApp'
  title: string
  subtitle: string
  QR: GatsbyResolvedAsset
  description: string
  storeLinks: Array<FooterStoreLinks>
}
function ZoneDownloadTheApp(props: ZoneDownloadTheAppProps): JSX.Element {
  const { title, subtitle, QR, description, storeLinks } = props

  setTimeout(() => {
    navigate('https://app.algbra.com/download')
  }, 5000)

  return (
    <Whitespace type="none" className={styles.wrapper}>
      <Container>
        <Row>
          <div className={styles.container}>
            <div className={styles.qrIcon}>
              <QrCodeIcon width={200} />
            </div>
            <div className={styles.qrDesc}>Can't scan the QR code?</div>

            <Button
              className={styles.downloadButton}
              size="normal"
              onClick={() => {
                window.open('https://app.algbra.com/download')
              }}
            >
              Download Now
            </Button>

            <div className={styles.appStoreIcons}>
              {map(({ image, url, alternativeText }) => {
                return (
                  <a key={`store-link-${image.id}`} href={url}>
                    <img
                      src={resolveAsAttachment(image)}
                      alt={alternativeText}
                      width={image.width}
                      height={image.height}
                      loading="lazy"
                    />
                  </a>
                )
              }, storeLinks as FooterStoreLinks[])}
            </div>

            <div
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
          </div>
        </Row>
      </Container>
    </Whitespace>
  )
}

export default ZoneDownloadTheApp
